module.exports = __webpack_public_path__ + "static/assets/7d460110954c70e9ae9c6718727cfb1a.svg";